// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'investment-valuation.page.title': 'Investment Valuations',
    'investment-valuation.page.search_results': 'Search Results',
    'investment-valuation.page.create.title': 'New Valuation',
    'investment-valuation.page.search.title': 'Find Valuations',
    'investment-valuation.page.all': 'All',

    'investment-valuation.button.cancel': 'Cancel',
    'investment-valuation.button.select': 'Select',
    'investment-valuation.button.find': 'Find Valuations',
    'investment-valuation.button.search': 'Apply',
    'investment-valuation.button.create': 'Add Valuation',
    'investment-valuation.button.new': 'New Valuation',
    'investment-valuation.button.save': 'Save Changes',
    'investment-valuation.button.rollback': 'Rollback Valuation',
    'investment-valuation.button.reset': 'Reset',

    'investment-valuation.placeholder.search': 'Search investment valuations',

    'investment-valuation.link.create_first_investment_valuation': 'Click here to create your first investment valuation',
    'investment-valuation.link.investment_valuations': ' Return to Investment Valuations',
    'investment-valuation.link.retry': 'Click here to retry',

    'investment-valuation.checkbox.all': 'Check All',
    'investment-valuation.checkbox.actions_label': 'with selected',

    'investment-valuation.label.investment_name': 'Investment',
    'investment-valuation.label.valuation_date': 'Valuation Date',
    'investment-valuation.label.currency_name': 'Currency',
    'investment-valuation.label.currency_value_in_cents': 'Value',
    'investment-valuation.label.notes': 'Notes',
    'investment-valuation.label.rollback_reason': 'Reason for rollback',

    'investment-valuation.sort.field_label': 'Field',
    'investment-valuation.sort.direction_label': 'Direction',
    'investment-valuation.sort.direction_ascending': 'Ascending',
    'investment-valuation.sort.direction_descending': 'Descending',

    'investment-valuation.modal.title.investment_valuation_rollback': 'Rollback Investment Valuation',

    'investment-valuation.modal.message.investment_valuation_rollback': 'Are you sure that you want to rollback this valuation?',

    'investment-valuation.success.message.investment_valuation_created': 'Your investment valuation has been created',
    'investment-valuation.success.message.investment_valuation_updated': 'Your investment valuation has been updated',
    'investment-valuation.success.message.investment_valuation_rolled_back': 'Your investment valuation has been rolled back',

    'investment-valuation.error.message.error_loading_page': 'Sorry, there was an error loading investment valuation.| Sorry, there was an error loading investment valuations.',
};
